import {server_api} from "../config";

export async function getServers(){
    const url = `${server_api}get_servers`;
    const { res, data } = await fetchWeb(url, { method: 'GET' });
    return data;
}

export async function getStatistics(){
    return await (await fetch(server_api+'get_statistics')).json()
}

/**
 * Парсит тело ошибки FastAPI (detail: string | array).
 */
export function parseApiErrorDetail(data) {
    if (!data || typeof data !== 'object') {
        return 'Не удалось выполнить запрос';
    }
    if (typeof data.message === 'string' && data.message.trim()) {
        return data.message;
    }
    const d = data.detail;
    if (typeof d === 'string') {
        return d;
    }
    if (Array.isArray(d)) {
        return d
            .map((item) => {
                if (typeof item === 'string') return item;
                if (item && typeof item.msg === 'string') return item.msg;
                return null;
            })
            .filter(Boolean)
            .join(' ');
    }
    return 'Не удалось выполнить запрос';
}

/**
 * Регистрация через сайт (POST /api/web/register).
 */
export async function registerWebUser({ login, password }) {
    const url = `${server_api}web/register`;
    const res = await fetch(url, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({ login, password }),
    });
    let data = {};
    try {
        data = await res.json();
    } catch {
        /* ignore */
    }
    if (!res.ok) {
        const err = new Error(parseApiErrorDetail(data));
        err.status = res.status;
        err.data = data;
        throw err;
    }
    return data;
}

/**
 * Вход через сайт (POST /api/web/login).
 */
export async function loginWebUser({ login, password }) {
    const url = `${server_api}web/login`;
    const res = await fetch(url, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({ login, password }),
    });

    let data = {};
    try {
        data = await res.json();
    } catch {
        /* ignore */
    }

    if (!res.ok) {
        const err = new Error(parseApiErrorDetail(data));
        err.status = res.status;
        err.data = data;
        throw err;
    }

    return data;
}

function getWebToken() {
    return localStorage.getItem('efv_web_token');
}

async function fetchWeb(url, { method = 'GET', headers = {}, body } = {}) {
    const token = getWebToken();
    const allHeaders = { ...headers };
    if (token) {
        allHeaders['Authorization'] = 'Bearer ' + token;
    }

    const res = await fetch(url, {
        method,
        headers: allHeaders,
        body,
    });
    let data = null;
    try {
        data = await res.json();
    } catch {
        /* ignore */
    }
    return { res, data };
}

/**
 * Личный кабинет: список конфигов пользователя.
 * GET /api/web/get_list_configs
 */
export async function getWebConfigs() {
    const url = `${server_api}web/get_list_configs`;
    const { res, data } = await fetchWeb(url, { method: 'GET' });
    if (!res.ok) {
        const err = new Error(parseApiErrorDetail(data));
        err.status = res.status;
        err.data = data;
        throw err;
    }
    if (data?.status && data.status !== 'OK') {
        const err = new Error(parseApiErrorDetail(data));
        err.status = res.status;
        err.data = data;
        throw err;
    }
    return data?.res || [];
}

/**
 * Личный кабинет: профиль пользователя (баланс/тариф/аватар).
 * GET /api/web/me
 */
export async function getWebProfile() {
    const url = `${server_api}web/me`;
    const { res, data } = await fetchWeb(url, { method: 'GET' });
    if (!res.ok || data?.status !== 'OK') {
        const err = new Error(parseApiErrorDetail(data));
        err.status = res.status;
        err.data = data;
        throw err;
    }
    return data?.res || null;
}

/**
 * Предпросмотр привязки: серверы из Telegram и с сайта, тарифы.
 * POST /api/web/bind-telegram/preview
 */
export async function previewBindTelegram(code) {
    const url = `${server_api}web/bind-telegram/preview`;
    const { res, data } = await fetchWeb(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ code: String(code).trim() }),
    });
    if (!res.ok || data?.status !== 'OK') {
        const err = new Error(parseApiErrorDetail(data));
        err.status = res.status;
        err.data = data;
        throw err;
    }
    return data?.res || null;
}

/**
 * Подтверждение привязки с выбранными серверами.
 * POST /api/web/bind-telegram/confirm
 */
export async function confirmBindTelegram(code, keepConfigIds) {
    const url = `${server_api}web/bind-telegram/confirm`;
    const { res, data } = await fetchWeb(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            code: String(code).trim(),
            keep_config_ids: Array.isArray(keepConfigIds) ? keepConfigIds.map((id) => Number(id)) : [],
        }),
    });
    if (!res.ok || data?.status !== 'OK') {
        const err = new Error(parseApiErrorDetail(data));
        err.status = res.status;
        err.data = data;
        throw err;
    }
    return data?.res || null;
}

/**
 * Личный кабинет: смена пароля.
 * POST /api/web/change-password
 */
export async function changeWebPassword({ oldPassword, newPassword }) {
    const url = `${server_api}web/change-password`;
    const { res, data } = await fetchWeb(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ old_password: oldPassword, new_password: newPassword }),
    });
    if (!res.ok) {
        const err = new Error(parseApiErrorDetail(data));
        err.status = res.status;
        err.data = data;
        throw err;
    }
    return data;
}

/**
 * Личный кабинет: создать конфиг.
 * POST /api/web/create_config
 */
export async function createWebConfig({ country, platform }) {
    const url = `${server_api}web/create_config`;
    const { res, data } = await fetchWeb(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ country, platform }),
    });

    if (!res.ok || data?.status !== 'OK') {
        const err = new Error(parseApiErrorDetail(data));
        err.status = res.status;
        err.data = data;
        throw err;
    }
    return {
        res: data?.res || null,
        warning: typeof data?.warning === 'string' ? data.warning : '',
    };
}

/** POST /api/web/vless/profiles */
export async function createVlessProfile({ country, is_premium = false }) {
    const url = `${server_api}web/vless/profiles`;
    const { res, data } = await fetchWeb(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ country, is_premium: Boolean(is_premium) }),
    });
    if (!res.ok || data?.status !== 'OK') {
        const err = new Error(parseApiErrorDetail(data));
        err.status = res.status;
        err.data = data;
        throw err;
    }
    return data?.res || null;
}

/** DELETE /api/web/vless/profiles/{id} */
export async function deleteVlessProfile(profileId) {
    const url = `${server_api}web/vless/profiles/${profileId}`;
    const { res, data } = await fetchWeb(url, { method: 'DELETE' });
    if (!res.ok || data?.status !== 'OK') {
        const err = new Error(parseApiErrorDetail(data));
        err.status = res.status;
        err.data = data;
        throw err;
    }
    return true;
}

/** GET /api/web/vless/countries */
export async function getVlessCountries() {
    const url = `${server_api}web/vless/countries`;
    const { res, data } = await fetchWeb(url, { method: 'GET' });
    if (!res.ok || data?.status !== 'OK') {
        return [];
    }
    return data?.res || [];
}

/** GET /api/web/vpn-subscription */
export async function getVpnSubscription() {
    const url = `${server_api}web/vpn-subscription`;
    const { res, data } = await fetchWeb(url, { method: 'GET' });
    if (!res.ok || data?.status !== 'OK') {
        return { exists: false, url: null, enabled: false };
    }
    return data?.res || { exists: false, url: null, enabled: false };
}

/** POST /api/web/vpn-subscription/ensure */
export async function ensureVpnSubscription() {
    const url = `${server_api}web/vpn-subscription/ensure`;
    const { res, data } = await fetchWeb(url, { method: 'POST' });
    if (!res.ok || data?.status !== 'OK') {
        const err = new Error(parseApiErrorDetail(data));
        err.status = res.status;
        err.data = data;
        throw err;
    }
    return data?.res || null;
}

/** POST /api/web/vpn-subscription/rotate */
export async function rotateVpnSubscription() {
    const url = `${server_api}web/vpn-subscription/rotate`;
    const { res, data } = await fetchWeb(url, { method: 'POST' });
    if (!res.ok || data?.status !== 'OK') {
        const err = new Error(parseApiErrorDetail(data));
        err.status = res.status;
        err.data = data;
        throw err;
    }
    return data?.res || null;
}

/**
 * Личный кабинет: создать Premium-конфиг.
 * POST /api/web/create_premium_config
 */
export async function createPremiumWebConfig({ country, platform }) {
    const url = `${server_api}web/create_premium_config`;
    const { res, data } = await fetchWeb(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ country, platform, confirmed: true }),
    });

    if (!res.ok || data?.status !== 'OK') {
        const err = new Error(parseApiErrorDetail(data));
        err.status = res.status;
        err.data = data;
        throw err;
    }

    return {
        res: data?.res || null,
        warning: typeof data?.warning === 'string' ? data.warning : '',
    };
}

/**
 * Личный кабинет: удалить конфиг.
 * POST /api/web/delete_config
 */
export async function deleteWebConfig({ config }) {
    const url = `${server_api}web/delete_config`;
    const { res, data } = await fetchWeb(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ config }),
    });

    if (!res.ok || data?.status !== 'OK') {
        const err = new Error(parseApiErrorDetail(data));
        err.status = res.status;
        err.data = data;
        throw err;
    }
    return true;
}

/**
 * Личный кабинет: создать ссылку на пополнение баланса.
 * POST /api/web/create_payment_link
 * @param {number} amount — сумма разового платежа (если isMonth=false)
 * @param {{ isMonth?: boolean }} [opts]
 */
export async function createWebPaymentLink(amount, opts = {}) {
    const isMonth = Boolean(opts.isMonth);
    const url = `${server_api}web/create_payment_link`;
    const body = isMonth ? { is_month: true } : { amount: Number(amount) };
    const { res, data } = await fetchWeb(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
    });
    if (!res.ok || data?.status !== 'OK') {
        const err = new Error(parseApiErrorDetail(data));
        err.status = res.status;
        err.data = data;
        throw err;
    }
    return data?.res || '';
}

/**
 * POST /api/web/cancel_subscription
 */
export async function cancelWebSubscription() {
    const url = `${server_api}web/cancel_subscription`;
    const { res, data } = await fetchWeb(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({}),
    });
    if (!res.ok || data?.status !== 'OK') {
        const err = new Error(parseApiErrorDetail(data));
        err.status = res.status;
        err.data = data;
        throw err;
    }
    return true;
}

/**
 * Публичная web-страница оплаты: поиск пользователя по username/telegram id.
 * POST /api/web/payment/find-user
 */
export async function findWebPaymentUser(query) {
    const url = `${server_api}web/payment/find-user`;
    const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ query: String(query || '').trim() }),
    });
    const data = await res.json().catch(() => null);
    if (!res.ok || data?.status !== 'OK') {
        const err = new Error(parseApiErrorDetail(data));
        err.status = res.status;
        err.data = data;
        throw err;
    }
    return data?.res || null;
}

/**
 * Публичная web-страница оплаты: создать ссылку на оплату для найденного пользователя.
 * POST /api/web/payment/top-up
 */
export async function topUpWebPaymentUser({ clientId, amount }) {
    const url = `${server_api}web/payment/top-up`;
    const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            client_id: Number(clientId),
            amount: Number(amount),
        }),
    });
    const data = await res.json().catch(() => null);
    if (!res.ok || data?.status !== 'OK') {
        const err = new Error(parseApiErrorDetail(data));
        err.status = res.status;
        err.data = data;
        throw err;
    }
    return data?.res?.payment_url || '';
}

/**
 * Личный кабинет: получить конфиг (скачать).
 * GET /api/web/get_config?config=...
 */
export async function downloadWebConfig(configName) {
    const token = getWebToken();
    const url = `${server_api}web/get_config?config=${encodeURIComponent(configName)}`;
    const res = await fetch(url, {
        method: 'GET',
        headers: token ? { Authorization: 'Bearer ' + token } : {},
    });
    if (!res.ok) {
        let data = null;
        try {
            data = await res.json();
        } catch {
            /* ignore */
        }
        const err = new Error(parseApiErrorDetail(data));
        err.status = res.status;
        err.data = data;
        throw err;
    }

    const blob = await res.blob();
    const contentDisposition = res.headers.get('content-disposition');
    let filename = configName + '.conf';
    if (contentDisposition) {
        const m = contentDisposition.match(/filename="?([^"]+)"?/i);
        if (m && m[1]) filename = m[1];
    }

    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(a.href);
    return true;
}
